exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-component='rename-account-form'] .rename-account {\n  width: 100%;\n}\n[data-component='rename-account-form'] .rename-account .form-rename-account {\n  width: 220px;\n  display: inline-block;\n}\n[data-component='rename-account-form'] .rename-account .form-rename-account > .form-control {\n  margin: 0;\n}\n[data-component='rename-account-form'] [data-component='signature'] {\n  margin: 40px 0 55px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/rename-your-account/rename-account-form/rename-account-form.component.styl
// module id = ../../../../../src/app/master/rename-your-account/rename-account-form/rename-account-form.component.styl
// module chunks = main